import * as React from 'react';
import { SVGProps } from 'react';

const IconWarningSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.149 1.38a1 1 0 0 1 1.702 0l4.99 8.095A1 1 0 0 1 10.99 11H1.01a1 1 0 0 1-.85-1.525l4.99-8.094zM6.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM6 3.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0V4a.5.5 0 0 0-.5-.5z"
    />
  </svg>
);
export default IconWarningSizeXs;
